var map = {
	"./image.vue": "kRr6",
	"./number-spinner.vue": "38bw",
	"./page.vue": "js5j",
	"./select-field.vue": "Ri+2",
	"./svg-icon.vue": "eFt/"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d/6I";


//////////////////
// WEBPACK FOOTER
// ./src/components nonrecursive \.vue$
// module id = d/6I
// module chunks = 44